import React from 'react';
import Layout from '../components/layout/Layout';

const AGB: React.FC = () => {
  React.useEffect(() => {
    document.title = "AGB | OetterliApps";
  }, []);

  return (
    <Layout>
      <div className="container mx-auto px-4 py-20 mt-16">
        <h1 className="text-3xl font-bold mb-8 text-sky-800">Allgemeine Geschäftsbedingungen</h1>
        
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <h2 className="text-xl font-semibold mb-4 text-sky-700">1. Geltungsbereich</h2>
          <p className="mb-4">
            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, die zwischen OetterliApps, 
            vertreten durch Patrick Oetterli, Musterstrasse 123, 8000 Zürich, Schweiz (nachfolgend "Anbieter") 
            und dem Kunden (nachfolgend "Kunde") geschlossen werden.
          </p>
          <p className="mb-4">
            Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, der Anbieter stimmt ihrer 
            Geltung ausdrücklich schriftlich zu.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">2. Vertragsgegenstand</h2>
          <p className="mb-4">
            Der Anbieter bietet Dienstleistungen im Bereich der digitalen Lösungen an, insbesondere:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li className="mb-2">Entwicklung von individuellen Softwarelösungen und Apps</li>
            <li className="mb-2">Prozessoptimierung und -automatisierung</li>
            <li className="mb-2">Beratung im Bereich digitaler Technologien</li>
            <li className="mb-2">Implementierung von CRM- und Marketing-Automatisierungslösungen</li>
          </ul>
          <p className="mb-4">
            Der genaue Umfang der Leistungen ergibt sich aus dem individuellen Angebot, das der Anbieter dem Kunden unterbreitet.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">3. Vertragsschluss</h2>
          <p className="mb-4">
            Der Vertrag kommt durch Annahme des vom Anbieter unterbreiteten Angebots durch den Kunden zustande. 
            Die Annahme kann schriftlich, per E-Mail oder durch konkludentes Handeln erfolgen.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">4. Preise und Zahlungsbedingungen</h2>
          <p className="mb-4">
            Die Preise für die Leistungen des Anbieters ergeben sich aus dem individuellen Angebot. 
            Alle Preise verstehen sich zuzüglich der gesetzlichen Mehrwertsteuer.
          </p>
          <p className="mb-4">
            Soweit nicht anders vereinbart, sind Rechnungen innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug zu zahlen.
          </p>
          <p className="mb-4">
            Bei Zahlungsverzug ist der Anbieter berechtigt, Verzugszinsen in Höhe von 5% über dem Basiszinssatz zu berechnen.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">5. Leistungserbringung</h2>
          <p className="mb-4">
            Der Anbieter erbringt seine Leistungen nach bestem Wissen und Gewissen und unter Einhaltung der anerkannten 
            Regeln der Technik.
          </p>
          <p className="mb-4">
            Termine und Fristen für die Leistungserbringung sind nur verbindlich, wenn sie vom Anbieter ausdrücklich 
            schriftlich als verbindlich bezeichnet worden sind.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">6. Mitwirkungspflichten des Kunden</h2>
          <p className="mb-4">
            Der Kunde ist verpflichtet, den Anbieter bei der Erbringung seiner Leistungen angemessen zu unterstützen. 
            Dazu gehört insbesondere die rechtzeitige Bereitstellung aller erforderlichen Informationen, Materialien 
            und Zugänge.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">7. Nutzungsrechte</h2>
          <p className="mb-4">
            Der Anbieter räumt dem Kunden an den erstellten Werken ein einfaches, zeitlich und räumlich unbeschränktes 
            Nutzungsrecht ein. Die Nutzungsrechte gehen erst mit vollständiger Bezahlung der vereinbarten Vergütung 
            auf den Kunden über.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">8. Gewährleistung</h2>
          <p className="mb-4">
            Der Anbieter gewährleistet, dass seine Leistungen die vereinbarte Beschaffenheit haben und nicht mit Mängeln 
            behaftet sind, die den Wert oder die Tauglichkeit zu dem gewöhnlichen oder nach dem Vertrag vorausgesetzten 
            Gebrauch aufheben oder mindern.
          </p>
          <p className="mb-4">
            Die Gewährleistungsfrist beträgt 12 Monate ab Abnahme der Leistung.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">9. Haftung</h2>
          <p className="mb-4">
            Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie bei Verletzung von Leben, 
            Körper oder Gesundheit.
          </p>
          <p className="mb-4">
            Im Übrigen haftet der Anbieter nur bei Verletzung einer vertragswesentlichen Pflicht und der Höhe nach 
            begrenzt auf den vertragstypisch vorhersehbaren Schaden.
          </p>
          
          <h2 className="text-xl font-semibold mb-4 mt-8 text-sky-700">10. Schlussbestimmungen</h2>
          <p className="mb-4">
            Es gilt das Recht der Schweizerischen Eidgenossenschaft unter Ausschluss des UN-Kaufrechts.
          </p>
          <p className="mb-4">
            Erfüllungsort und ausschließlicher Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit diesem 
            Vertrag ist Zürich, Schweiz.
          </p>
          <p className="mb-4">
            Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, so wird dadurch die Wirksamkeit der 
            übrigen Bestimmungen nicht berührt.
          </p>
          
          <p className="mt-8 text-sm text-gray-600">
            Stand: April 2025
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default AGB;
